module.exports = __webpack_public_path__ + "img/edu-assist.e9cade6a.svg";